<template>
  <div>
    <!-- Show active calls -->
    <div v-if="callAttempt.is_initiating || startingCall">
      <div class="box is-shadowless has-background-blue-light py-1">
                <span class="has-text-weight-semibold has-text-blue">
                    Bezig met verbinden<connecting-dots></connecting-dots>
                </span>
      </div>
    </div>
    <div v-else-if="callAttempt.is_calling">
      <div class="box is-shadowless has-background-success-light py-1">
                <span class="has-text-weight-semibold has-text-green">
                    <div class="columns has-text-semibold is-paddingless is-marginless">
                        <div class="column align-items-center is-paddingless">
                            Bezig met bellen...
                        </div>
                        <div class="column has-text-size-30 align-items-center is-paddingless justify-start">
                            <timer v-model="time"></timer>
                        </div>
                        <div class="column is-half align-items-center is-paddingless">
                            <div v-if="time > 10 * 60">
                                <span v-if="numberOfCalls > 1">
                                    Je hebt nog {{ numberOfCalls }} andere gesprekken te gaan.
                                </span>
                                <span v-else>
                                    Dit is je laatste gesprek.
                                </span>
                            </div>
                        </div>
                    </div>
                </span>
      </div>
    </div>
    <div v-else-if="callAttempt.is_failed">
      <div class="box is-shadowless has-background-danger-light py-1">
        <div class="columns has-text-weight-semibold has-text-danger align-items-center">
          <div class="column align-items-center">
            {{ callAttempt.status_name }}, probeer later opnieuw.
          </div>
          <div v-if="callingEnabled" class="column is-one-third align-items-center">
            <button class="button is-primary"
                    @click="newCall()">
                            <span class="icon">
                                <i class="fas fa-phone"></i>
                            </span>
              <span>bel opnieuw</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="callAttempt.is_finished">
      <div class="box is-shadowless has-background-success-light py-1">
                <div class=" columns has-text-weight-semibold has-text-green">
                    <div class="column is-narrow has-text-size-30">
                        <i class="far fa-check-circle"></i>
                    </div>
                    <div class="column align-items-center">
                        Gesprek beëindigd
                    </div>
                    <div class="column has-text-size-30 align-items-center justify-center">
                        <timer v-model="time"
                               :start="false"></timer>
                    </div>
                    <div v-if="callingEnabled" class="column is-half align-items-center">
                        Iets vergeten of verbinding verbroken?
                        <button class="button is-primary"
                                @click="newCall()">
                            <span class="icon">
                                <i class="fas fa-phone"></i>
                            </span>
                            <span>bel opnieuw</span>
                        </button>
                    </div>
                </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CallAttempt } from '../../../models/CallAttempt';
  import ConnectingDots from './ConnectingDots';
  import Timer from './Timer';
  import { isNumber } from 'lodash-es';

  export default {
    components: { ConnectingDots, Timer },
    props: {
      callAttempt: {
        type: CallAttempt,
        required: true
      },
      numberOfCalls: {
        type: Number
      },
      startingCall: {
        type: Boolean,
        required: true
      },
      callingEnabled: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        time: 0
      };
    },
    mounted () {
      this.time = isNumber(this.callAttempt.duration)
        ? this.callAttempt.duration
        : 0;
    },
    methods: {
      newCall () {
        this.time = 0;
        this.$emit('newCall');
      }
    }
  };
</script>
